import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback, useRef } from 'react'
import { useIntl } from 'react-intl'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import FilterChip from 'LuxKit/Chips/FilterChip'
import CalendarRoomDropdown from './CalendarRoomDropdown'

interface Props {
  open: boolean
}

function CalendarRoomSelect(props: Props) {
  const { open } = props
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  const dispatch = useOfferPageDispatch()
  const intl = useIntl()

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
  }, [dispatch])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
  }, [dispatch])

  const filterByRoomLabel = intl.formatMessage({
    id: 'FzyR0c1wEZMRCCa2Bg1J',
    defaultMessage: 'Filter by room',
    description: 'Label for filter chip to filter by room in bedbank date picker',
  })

  return (
    <>
      <FilterChip
        size="medium"
        ref={triggerRef}
        onClick={onToggleOpen}
        endIcon={<DropdownChevron open={open} />}
      >
        {filterByRoomLabel}
      </FilterChip>
      <CalendarRoomDropdown
        open={open}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        onClose={onClose}
      />
    </>
  )
}

export default withOfferPageState((state) => ({
  open: state.activeSubFilter === 'room',
}), CalendarRoomSelect)
